import React from 'react';
import type { SolutionPremiumSections } from './types';

export const SolutionTrustedBy: React.FC<{
  trustedBy: SolutionPremiumSections['trustedBy'];
}> = ({ trustedBy }) => {
  const withSrc = trustedBy.logos.filter((logo) => logo.src);
  const textOnly = trustedBy.logos.filter((logo) => !logo.src);
  const loop = withSrc.length > 0 ? [...withSrc, ...withSrc] : [];

  return (
    <section className="solution-trusted" aria-labelledby="solution-trusted-title">
      <div className="solution-trusted__inner">
        <h2 id="solution-trusted-title" className="solution-trusted__title">
          {trustedBy.title}
        </h2>
        {withSrc.length > 0 ? (
          <div className="solution-trusted__viewport">
            <div className="solution-trusted__track">
              {loop.map((logo, index) => {
                const isClone = index >= withSrc.length;
                return (
                  <div
                    key={`${logo.src}-${index}`}
                    className="solution-trusted__tile"
                    aria-hidden={isClone}
                  >
                    <img
                      src={logo.src}
                      alt={isClone ? '' : logo.alt ?? logo.name}
                      className="solution-trusted__img"
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                );
              })}
            </div>
          </div>
        ) : (
          <ul className="solution-trusted__names">
            {textOnly.map((logo) => (
              <li key={logo.name}>{logo.name}</li>
            ))}
          </ul>
        )}
      </div>
    </section>
  );
};
